<template>
  <div class="grid-table">
    <!-- Search -->
    <div
      v-if="search || filter"
      class="input-row"
    >
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div
          v-if="filter"
          style="margin-top:8px;"
        >
          <a
            v-if="!showFilter"
            href="#"
            @click="processShowFilter(true)"
          ><span class="fa fa-chevron-right" /> {{ trans('subscription.show_filter_and_export') }}</a>
          <a
            v-else
            href="#"
            @click="processShowFilter(false)"
          ><span class="fa fa-chevron-down" /> {{ trans('subscription.hide_filter_and_export') }}</a>
        </div>
        <div
          v-if="explanation"
          style="flex: 0 0 auto; margin-top: 8px;"
        >
          <slot name="explanation" />
        </div>
        <div
          v-if="search"
          style="flex: 0 0 auto"
        >
          <input-component
            id="search"
            v-model="quickFilter"
            style="margin-top: 0px !important;"
            type="search"
            :placeholder="trans('core.search')"
            class="search pull-right"
            @keyup="onQuickFilterChange"
          />
        </div>
      </div>
    </div>

    <!-- Filter -->
    <div
      v-if="filter"
      class="input-row"
    >
      <slot name="filter" />
    </div>

    <ag-grid-vue
      class="ag-theme-material"
      style="width: 100%; flex: 1 1 auto"
      :column-defs="columnDefs"
      :row-data="rowData"
      :grid-options="gridOptions"
      :pagination-auto-page-size="true"
      :suppress-pagination-panel="true"
      @paginationChanged="onPaginationChanged"
      @gridReady="onGridReady"
      @gridSizeChanged="onGridSizeChanged"
      v-on="$listeners"
    />

    <div
      v-if="paginate"
    >
      <!-- pagination -->
      <div class="pull-right">
        <button
          class="btn btn-default"
          :disabled="pagination.currentPage === 1"
          @click="gridApi.paginationGoToPreviousPage()"
        >
          <i
            class="fa fa-angle-left"
            aria-hidden="true"
          />
        </button>
        <span>{{ trans('core.page') }} <strong>{{ pagination.currentPage }}</strong> {{ trans('core.of') }} {{ pagination.totalPages }}</span>
        <button
          class="btn btn-default"
          :disabled="pagination.currentPage === pagination.totalPages"
          @click="gridApi.paginationGoToNextPage()"
        >
          <i
            class="fa fa-angle-right"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import 'ag-grid-community/styles/ag-theme-material.css'
import { AgGridVue } from 'ag-grid-vue'
import 'ag-grid-community/styles/ag-grid.css'
import InputComponent from '@/employees/components/FormComponents/InputComponent'

export default {
  name: 'AgGridTable',

  components: { InputComponent, AgGridVue },

  props: {
    paginate: {
      required: false,
      default: true,
      type: Boolean,
    },
    filter: {
      required: false,
      default: false,
      type: Boolean,
    },
    search: {
      required: false,
      default: true,
      type: Boolean,
    },
    gridOptions: {
      required: true,
      type: Object,
    },
    columnDefs: {
      required: true,
      type: Array,
    },
    rowData: {
      required: true,
      type: Array,
    },
    fitCols: {
      required: false,
      default: true,
      type: Boolean,
    },
    explanation: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      quickFilter: '',
      pagination: {},
      showFilter: true,
      gridApi: {},
    }
  },

  computed: {},

  methods: {
    onQuickFilterChange () {
      this.gridApi.setGridOption('quickFilterText', this.quickFilter)
    },

    onPaginationChanged () {
      if (Object.keys(this.gridApi).length === 0) {
        return
      }

      this.pagination = {
        lastPage: this.gridApi.paginationIsLastPageFound(),
        pageSize: this.gridApi.paginationGetPageSize(),
        currentPage: this.gridApi.paginationGetCurrentPage() + 1,
        totalPages: this.gridApi.paginationGetTotalPages(),
      }
    },

    onGridReady (params) {
      this.fitColumns(params)

      this.gridApi = params.api
    },

    onGridSizeChanged (params) {
      // this.fitColumns(params)
    },

    fitColumns (params) {
      if (this.fitCols) {
        params.api.autoSizeAllColumns()
      }
    },

    processShowFilter (input) {
      this.$emit('showFilter', { showFilter: input })
      this.showFilter = input
    },
  },
}
</script>

<style lang="scss">
.grid-table .ag-theme-material{
  height: 400px !important;
}

.ag-root-wrapper {
  border: none;
}

  .search {
    .form-control {
      border-radius: 5px;
      padding: 19px;
    }
  }

  .input-row {
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 5px;
  }

    .grid-table {
      display: flex;
      flex-direction: column;
      height: 100%;

      .ag-row .ag-cell {
        display: flex;
        align-items: center;

        &.status {
          justify-content: center; /* align horizontal */
        }

        &.ag-cell-focus {
          border-color: transparent !important;
        }
      }

      .ag-row {
        border-top: 1px solid #dee2e6;
      }

      .ag-cell {
        border-right: none;
      }

      .ag-horizontal-left-spacer, .ag-horizontal-right-spacer {
        visibility: hidden;
      }

      .ag-theme-material {
        font-family: inherit;
        font-size: 1rem;

        .ag-header {
          font-family: inherit;
          font-size: inherit;

          .ag-header-cell {
            color: #212529;
            padding-left: 5px;
            padding-right: 5px;
          }

          .ag-header-cell-text {
            font-size: 14px;
            padding: 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          }
        }

        .ag-cell {
          padding-left: 12px;
          padding-right: 12px;
        }
      }

      .ag-center-cols-viewport {
        overflow-x: hidden;
      }

      .ag-header-cell-resize:after {
        content: "";
        position: absolute;
        z-index: 1;
        display: block;
        left: calc(50% - 1px);
        width: 1px;
        height: 60%;
        top: 20%;
        background-color: rgba(186, 191, 199, .5);
      }
    }
</style>
